var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-charts',{staticClass:"echarts",attrs:{"options":_vm.option}})
}
var staticRenderFns = []

export { render, staticRenderFns }